module.exports = __webpack_public_path__ + "img/ic24Dog.25c1af9d.svg";